/**
 * LoopEndIcon/index.js
 * desc: loop end step icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LoopEndIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="loop-end icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.loopEnd.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.20067 14.3505H3.32527C2.4099 14.3505 1.57807 13.9864 0.976121 13.4005C0.374043 12.8144 0 12.0043 0 11.1137V3.23677C0 2.34606 0.374215 1.53637 0.976293 0.950312C1.57837 0.364256 2.41033 0 3.32527 0H18.6747C19.5897 0 20.4219 0.36409 21.024 0.950146C21.626 1.53607 22 2.34577 22 3.23677V11.1137C22 12.0049 21.6263 12.8146 21.0242 13.4006C20.4221 13.9867 19.5904 14.3505 18.6747 14.3505H12.717V16.3966C12.717 16.7299 12.4395 17 12.0971 17C11.9372 17.0002 11.7834 16.9401 11.6681 16.8322L7.37993 13.5352C7.11253 13.3296 7.06707 12.9519 7.27826 12.6916C7.3108 12.6514 7.34849 12.6154 7.39041 12.5845L11.7146 9.2599C11.982 9.05437 12.3701 9.09862 12.5813 9.35886C12.6675 9.46481 12.7143 9.59605 12.714 9.73119H12.717V11.9369H18.6747C18.9062 11.9369 19.1175 11.8439 19.2712 11.6943C19.4249 11.5447 19.5204 11.3389 19.5204 11.1137V3.23677C19.5204 3.0118 19.4247 2.8061 19.2711 2.65649C19.1172 2.50675 18.9057 2.41357 18.6747 2.41357H3.32527C3.09461 2.41357 2.88312 2.50692 2.72929 2.65666C2.57546 2.80639 2.47955 3.01209 2.47955 3.23677V11.1137C2.47955 11.3386 2.57529 11.5444 2.72912 11.6941C2.88282 11.8437 3.09414 11.9369 3.32527 11.9369H4.20067V14.3505Z"/>
        </svg>
    </IconButton>
);


export default LoopEndIcon;
